import apiClient from './client';

export interface ShoppingCartItem {
  id: string;
  name: string;
  amount: number | null;
  unit: string | null;
  notes: string | null;
  recipe_id: string | null;
  recipe_title: string | null;
  checked: boolean;
  added_at: string;
}

export interface AddToCartInput {
  name: string;
  amount?: number | null;
  unit?: string | null;
  notes?: string | null;
  recipe_id?: string;
  recipe_title?: string;
}

export interface UpdateCartItemInput {
  checked?: boolean;
  amount?: number;
  notes?: string;
}

export const shoppingCartApi = {
  get: async () => {
    const response = await apiClient.get<{
      data: { items: ShoppingCartItem[]; count: number };
    }>('/shopping-cart');
    return response.data.data;
  },

  addItems: async (items: AddToCartInput[]) => {
    const response = await apiClient.post<{
      data: { items: ShoppingCartItem[]; count: number };
    }>('/shopping-cart/items', { items });
    return response.data.data;
  },

  updateItem: async (itemId: string, data: UpdateCartItemInput) => {
    const response = await apiClient.patch<{
      data: { items: ShoppingCartItem[]; count: number };
    }>(`/shopping-cart/items/${itemId}`, data);
    return response.data.data;
  },

  removeItem: async (itemId: string) => {
    const response = await apiClient.delete<{
      data: { items: ShoppingCartItem[]; count: number };
    }>(`/shopping-cart/items/${itemId}`);
    return response.data.data;
  },

  clear: async () => {
    await apiClient.delete('/shopping-cart');
  },
};
